var React = require('react');

function LongArrowLeft (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M128.09 220H424a24 24 0 0 1 24 24v24a24 24 0 0 1-24 24H128.09l-35.66-36z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M142.56 409L7 273.5v-.06a25.23 25.23 0 0 1 0-34.84l.06-.06 135.5-135.49a24 24 0 0 1 33.94 0l17 17a24 24 0 0 1 0 33.94L92.43 256 193.5 358a24 24 0 0 1 0 33.94l-17 17a24 24 0 0 1-33.94.06z","className":"fa-primary","key":2})]);
}

LongArrowLeft.defaultProps = {"viewBox":"0 0 448 512","className":"icon"};

module.exports = LongArrowLeft;

LongArrowLeft.default = LongArrowLeft;
